import { getAnalyticsActor, posthog } from './posthog'

/**
 * Thu ngân bấm nút "+" / "−" cạnh ô số lượng một dòng hàng trong giỏ POS
 * (M-185 thêm nút "−"):
 *   - `direction`: `increase` (nút "+") hoặc `decrease` (nút "−").
 *   - `reached_minimum`: lần bấm "−" đưa số lượng về đúng 1 (mức thấp nhất,
 *     nút "−" tắt sau đó). Luôn `false` với `increase`.
 *
 * Gõ tay vào ô số lượng KHÔNG phát event. Không gửi mã sản phẩm, số lượng,
 * đơn giá hay tên khách: chỉ enum/boolean. Analytics lỗi hoặc tắt không được
 * chặn việc đổi số lượng.
 */
export type PosCartQuantityDirection = 'increase' | 'decrease'

export function capturePosCartQuantityStep(input: {
    direction: PosCartQuantityDirection
    reachedMinimum: boolean
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('pos_cart_quantity_step', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            direction: input.direction,
            reached_minimum: input.reachedMinimum,
        })
    } catch {
        // Analytics không được chặn việc đổi số lượng.
    }
}
